export const getGeneralQuestionList = (payload?: any) => ({
    type: "@saga/GET_GENERAL_QUESTION_LIST",
    payload
});

